var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UI_icon_category_light",
    "data-name": "UI icon/category/light",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.5,
    height: 24.5,
    viewBox: "0 0 24.5 24.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_241_Stroke_",
    "data-name": "Rectangle 241 (Stroke)",
    d: "M6.806,10.889H4.083A4.088,4.088,0,0,1,0,6.806V4.083A4.088,4.088,0,0,1,4.083,0H6.806a4.088,4.088,0,0,1,4.083,4.083V6.806A4.088,4.088,0,0,1,6.806,10.889ZM4.083,2.722A1.363,1.363,0,0,0,2.722,4.083V6.806A1.363,1.363,0,0,0,4.083,8.167H6.806A1.363,1.363,0,0,0,8.167,6.806V4.083A1.363,1.363,0,0,0,6.806,2.722Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_243_Stroke_",
    "data-name": "Rectangle 243 (Stroke)",
    d: "M6.806,10.889H4.083A4.088,4.088,0,0,1,0,6.806V4.083A4.088,4.088,0,0,1,4.083,0H6.806a4.088,4.088,0,0,1,4.083,4.083V6.806A4.088,4.088,0,0,1,6.806,10.889ZM4.083,2.722A1.363,1.363,0,0,0,2.722,4.083V6.806A1.363,1.363,0,0,0,4.083,8.167H6.806A1.363,1.363,0,0,0,8.167,6.806V4.083A1.363,1.363,0,0,0,6.806,2.722Z",
    transform: "translate(0 13.611)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_242_Stroke_",
    "data-name": "Rectangle 242 (Stroke)",
    d: "M6.806,10.889H4.083A4.088,4.088,0,0,1,0,6.806V4.083A4.088,4.088,0,0,1,4.083,0H6.806a4.088,4.088,0,0,1,4.083,4.083V6.806A4.088,4.088,0,0,1,6.806,10.889ZM4.083,2.722A1.363,1.363,0,0,0,2.722,4.083V6.806A1.363,1.363,0,0,0,4.083,8.167H6.806A1.363,1.363,0,0,0,8.167,6.806V4.083A1.363,1.363,0,0,0,6.806,2.722Z",
    transform: "translate(13.611)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_244_Stroke_",
    "data-name": "Rectangle 244 (Stroke)",
    d: "M6.806,10.889H4.083A4.088,4.088,0,0,1,0,6.806V4.083A4.088,4.088,0,0,1,4.083,0H6.806a4.088,4.088,0,0,1,4.083,4.083V6.806A4.088,4.088,0,0,1,6.806,10.889ZM4.083,2.722A1.363,1.363,0,0,0,2.722,4.083V6.806A1.363,1.363,0,0,0,4.083,8.167H6.806A1.363,1.363,0,0,0,8.167,6.806V4.083A1.363,1.363,0,0,0,6.806,2.722Z",
    transform: "translate(13.611 13.611)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackages);
export default __webpack_public_path__ + "static/media/packages.28fc7a150e3c336eefab6aaa49f2b413.svg";
export { ForwardRef as ReactComponent };